import script from "./View.vue?vue&type=script&lang=ts&setup=true"
export * from "./View.vue?vue&type=script&lang=ts&setup=true"

import "./View.vue?vue&type=style&index=0&id=7198c046&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7198c046"]])

export default __exports__